export default __webpack_public_path__ + "static/media/Shrimp.48947c46.webp";